<template>
  <v-row class="header-title-two">
    <v-col>
      <v-skeleton-loader
        :loading="loading"
        type="heading"
        :class="{ 'header-loading-2': true, [loaderClass]: loaderClass && loading }"
      >
        <h1 class="text-sm-12">{{ title }}</h1>
      </v-skeleton-loader>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: ['title', 'loading', 'loaderClass'],
};
</script>

<style scoped>
.header-title-two {
  margin-top: unset !important;
  margin-bottom: unset !important;
}
.header-title-two >>> .v-skeleton-loader__heading {
  background-color: #e4e6eb !important;
}
h1 {
  font-weight: 500;
  font-size: 1.25em;
  line-height: 1.5rem;
  letter-spacing: 0.1px;
  text-transform: capitalize;
  color: #234025;
  padding-bottom: 4px;
}
@media screen and (max-width: 600px) {
  h1 {
    font-size: 0.9375rem;
  }
}
</style>
